module.exports = __webpack_public_path__ + "6748227057e70b31d0ac510102976ef5.MP3";